import { BoxProps, Center, Img } from '@wegroup/design-system';
import React from 'react';
import useAuth from '../../../../app/src/features/authentication/hooks/useAuth';

const CompanyLogo: React.FC<React.PropsWithChildren<BoxProps>> = ({
  ...props
}) => {
  const { distribution, campaign } = useAuth();
  const distLogo = distribution?.logos?.logo;

  const logo = campaign?.logo || distLogo || distribution?.logos?.logo || '';

  return (
    <Center h="100%" maxH="56" overflow="hidden" {...props}>
      <Img
        objectFit="contain"
        maxH="56"
        maxW="56"
        src={logo}
        alt="Company logo"
      />
    </Center>
  );
};

export default CompanyLogo;
